import { render, staticRenderFns } from "./AccountDeleted.vue?vue&type=template&id=4b0eab66&scoped=true"
import script from "./AccountDeleted.vue?vue&type=script&lang=ts"
export * from "./AccountDeleted.vue?vue&type=script&lang=ts"
import style0 from "./AccountDeleted.vue?vue&type=style&index=0&id=4b0eab66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0eab66",
  null
  
)

export default component.exports